/* eslint-disable react/jsx-no-leaked-render, max-statements */
import { Button, Form, InputGroup, Spinner } from "react-bootstrap";
import { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { useMutation } from "react-query";

import getPromoCodeMutation from "./getPromoCodeMutation";

const PromoCodeInput = ({ onSuccess }) => {
	const [loading, setLoading] = useState(false);
	const [code, setCode] = useState("");
	const [codeError, setCodeError] = useState(null);
	const [success, setSuccess] = useState(null);
	const [codeSubmitted, setCodeSubmitted] = useState(false);

	const {
		mutateAsync: validatePromoCode
	} = getPromoCodeMutation(useMutation);

	const handleChange = useCallback((evt) => {
		setCode(evt.target.value);
		setCodeSubmitted(false);
		if (onSuccess) {
			onSuccess(null);
		}

	}, []);

	const handleSubmit = useCallback(async (evt) => {
		evt.preventDefault();
		setLoading(true);
		setCodeError(null);
		setSuccess(null);
		try {
			const { data } = await validatePromoCode({ code });
			if (onSuccess) {
				onSuccess(data.data.validatePromoCode.promo_code);
			}
			setSuccess("Promo code applied successfully!");
		} catch (error) {
			setCodeError("Failed to apply promo code.");
		} finally {
			setCodeSubmitted(true);
			setLoading(false);
		}
	}, [code, validatePromoCode, onSuccess]);

	const clearCode = useCallback(() => {
		setCode("");
		setCodeSubmitted(false);
		setCodeError(null);
		setSuccess(null);
		if (onSuccess) {
			onSuccess(null);
		}
	}, [onSuccess]);

	const handleKeyDown = useCallback((evt) => {
		if (evt.key === "Enter") {
			handleSubmit(evt);
		}
	}, [handleSubmit]);

	return (
		<Form.Group className="mb-3" controlId="promoCode">
			<Form.Label>Promo Code</Form.Label>
			<InputGroup>
				<Form.Control
					isInvalid={codeSubmitted && !!codeError}
					isValid={codeSubmitted && !!success}
					onChange={handleChange}
					onKeyDown={handleKeyDown}
					placeholder="Enter promo code" type="text"
					value={code}
				/>
				{
					!!success && !loading && codeSubmitted ? (
						<Button id="clear-promo-code" onClick={clearCode} variant="outline-secondary">
							Clear
						</Button>
					) : (
						<Button disabled={loading} id="apply-promo-code" onClick={handleSubmit} variant="outline-secondary">
							{loading ? <Spinner animation="border" size="sm" /> : "Apply"}
						</Button>
					)
				}
				{codeError ? <Form.Control.Feedback type="invalid">{codeError}</Form.Control.Feedback> : null}
				{success ? <Form.Control.Feedback type="valid">{success}</Form.Control.Feedback> : null}
			</InputGroup>
		</Form.Group>
	);
};

PromoCodeInput.propTypes = {
	onSuccess: PropTypes.func
};

PromoCodeInput.defaultProps = {
	onSuccess: null
};

export default PromoCodeInput;